module.exports = __webpack_public_path__ + "static/real_estate_accounting-ae0d3b500f13e3b45777ae767330ef1e.png";